import { Box, Button, Flex, Text } from '@chakra-ui/react'
import { InspectionArea } from '@editor/interfaces/inspection'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'
import { Link } from 'react-router'

import { Steps, Tools } from '../definitions'

const Overlay = ({ leftInspectionArea }: { leftInspectionArea: InspectionArea | null }) => {
  const currentStep = useSelector((state: RootState) => state.pcdAlignment.currentStep)
  const currentTool = useSelector((state: RootState) => state.pcdAlignment.currentTool)
  const project = useSelector((state: RootState) => state.page.project)
  const leftProgress = useSelector((state: RootState) => state.pcdAlignment.leftProgress)
  const rightProgress = useSelector((state: RootState) => state.pcdAlignment.rightProgress)

  return (
    <Flex
      id="overlay"
      className={[currentStep === Steps.FineTuneOrSave || currentTool !== Tools.PCDAlignment ? 'non-split' : ''].join(
        ' ',
      )}
    >
      {/* Area is null; Ask user to choose an area if none are selected */}
      {leftInspectionArea === null ? (
        <Flex className="left">
          <Text>エリアを選択してください。</Text>
        </Flex>
      ) : null}

      {/* Area not null but progress -1; Chosen area has no file */}
      {leftInspectionArea !== null && leftProgress === -1 ? (
        <Flex className="left" flexDirection="column" gap={4}>
          <Text fontSize="1.1rem">
            点群ファイルがアップロードされていません。3D画面に進んでアップロードしてください。
          </Text>
          <Button asChild variant="outline" color="white" fontSize="1.3rem" pointerEvents="all">
            <Link to={`/projects/${project?.project_id}/editor?area=${leftInspectionArea?.inspection_area_id}`}>
              3D画面に移動
            </Link>
          </Button>
        </Flex>
      ) : null}

      {/* Area not null; area chosen has file, show progress  */}
      {leftInspectionArea !== null && leftProgress !== -1 ? (
        <Flex className="left" opacity={leftProgress === null ? 0 : 1}>
          Downloading {Math.round(leftProgress || 0)}%
        </Flex>
      ) : null}

      <Box id="divider" />

      {rightProgress === -1 ? (
        <Flex className="right" flexDirection="column" gap={4}>
          <Text fontSize="1.1rem">
            点群ファイルがアップロードされていません。3D画面に進んでアップロードしてください。
          </Text>
          <Button asChild variant="outline" color="white" fontSize="1.3rem" pointerEvents="all">
            <Link to={`/projects/${project?.project_id}/editor?area=${leftInspectionArea?.inspection_area_id}`}>
              3D画面に移動
            </Link>
          </Button>
        </Flex>
      ) : (
        <Flex className="right" opacity={rightProgress === null ? 0 : 1}>
          Downloading {Math.round(rightProgress || 0)}%
        </Flex>
      )}
    </Flex>
  )
}

export default Overlay
